import React from 'react';
import { PieChart, Pie,  Tooltip, ResponsiveContainer } from 'recharts';

const PieChartComponent = ({data,title}) => {
    return (
        <div style={{ backgroundColor: "var(--jy-surface-1)", boxShadow: "var(--jy-card-shadow)", borderRadius: "10px" ,height:"315px"}}>
         <div className="title" style={{ padding: "16px 25px", fontWeight: "bold", fontSize: "14px", color: "var(--jy-text-secondary)" }}>{title}</div>
         <ResponsiveContainer width="100%" height="85%">
          <PieChart width={400} height={280}>
            <Pie
              dataKey="value"
              isAnimationActive={false}
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
              label
            />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        </div>
      );
}

export default PieChartComponent;
